import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const menuRoleApi = createApi({
    reducerPath: "base/menuRole",
    baseQuery: axiosBaseQuery,
    tagTypes: ["menuRoleList"],
    endpoints: (builder) => ({
        menuRoleFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['menuRoleList'],
            query: (query = '') => ({
                url: "/base/menuRole" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        menuRoleCreate: builder.mutation({
            invalidatesTags: ['menuRoleList'],
            query: (data) => ({ url: "/base/menuRole", method: "POST", data })
        }),
        menuRoleUpdate: builder.mutation({
            invalidatesTags: ['menuRoleList'],
            query: (data) => ({ url: "/base/menuRole/" + data.id, method: "PUT", data })
        }),
        menuRoleDelete: builder.mutation({
            invalidatesTags: ['menuRoleList'],
            query: (id) => ({ url: "/base/menuRole/" + id, method: "DELETE" })
        }),
    })
})

export const { useMenuRoleFindAllQuery, useMenuRoleCreateMutation, useMenuRoleUpdateMutation, useMenuRoleDeleteMutation } = menuRoleApi;
export { menuRoleApi };
